import { retrieveAllAppointment } from "../../../redux/admin-slices/appointment.slice";
import TablePagination from "../../../components/common/PaginationSkell";
import EntriesSelect from "../../../components/ui/EntriesSelect";
import { useChatInitiate } from "../../../hooks/useChatInitiate";
import Messages from "../../../components/common/messages/chat";
import TableSkell from "../../../components/common/TableSkell";
import SelectInput from "../../../components/ui/SelectInput";
import InputFieldA from "../../../components/ui/InputFieldA";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useRef } from "react";
import { debounce, formatDate, formatTime } from "../../../utils/helper";
import Icons from "../../../assets/js/Icons";

import {
  Avatar, Box, Button, Chip, Grid2 as Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, IconButton, Container,
  TableRow, Typography, Collapse,
} from "@mui/material";

function AllAppointments() {
  const dispatch = useDispatch();
  const searchRef = useRef("");
  const statusRef = useRef("");
  const entriesRef = useRef("");
  const startDateRef = useRef("");
  const endDateRef = useRef("");
  const [data, setData] = useState(null);
  const { isActive, initiateChat } = useChatInitiate();
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleRetrieveAppointments = (filters) => {
    dispatch(
      retrieveAllAppointment({
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
        startDate: startDateRef?.current?.value || null,
        endDate: endDateRef?.current?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => { });
  };
  const handleSearch = debounce(() => {
    handleRetrieveAppointments();
  }, 1000);

  useEffect(() => {
    handleRetrieveAppointments();
    // eslint-disable-next-line
  }, []);
  const statusConfig = {
    pending: { label: "Pending", bg: "#fff3e0", color: "#e65100" },
    confirmed: { label: "Confirmed", bg: "#e8f5e8", color: "#2e7d32" },
    completed: { label: "Completed", bg: "#e8f5e9", color: "#2e7d32" },
    rejected: { label: "Rejected", bg: "#ffebee", color: "#c62828" },
    cancelled: { label: "Cancelled", bg: "#f5f5f5", color: "#616161" },
    late_cancelled: { label: "Late Cancelled", bg: "#f5f5f5", color: "#616161" },
    expired: { label: "Expired", bg: "#ffebee", color: "#c62828" },
    no_show_specialist: { label: "No-Show (Specialist)", bg: "#fff3e0", color: "#f57c00" },
    no_show_member: { label: "No-Show (Member)", bg: "#fff3e0", color: "#f57c00" },
  };
  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">All Appointments</Typography>
      </Box>

      <Grid
        container
        spacing={1}
        className="filters-grid"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search by name "
            ref={searchRef}
            placeholder={"Search..."}
            onChangeFun={handleSearch}
          />
        </Grid>

        {/* Date Range */}
        <Grid
          container
          direction="row"
          spacing={2}
          size={{ xs: 12, sm: 6, lg: "auto" }}
        >
          <Grid item>
            <InputFieldA
              label="Start Date"
              type="date"
              inputRef={startDateRef}
            />
          </Grid>

          <Grid item>
            <InputFieldA label="End Date" type="date" inputRef={endDateRef} />
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              sx={{ marginTop: "22px", padding: "10px 18px" }}
              onClick={handleRetrieveAppointments}
            >
              Apply
            </Button>
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAppointments();
              }, 0);
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Appointment Status"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="All"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAppointments();
              }, 0);
            }}
            options={[
              { name: "Confirmed", value: "confirmed" },
              { name: "Pending", value: "pending" },
              { name: "Completed", value: "completed" },
              { name: "Cancelled", value: "cancelled" },
              { name: "Rejected", value: "rejected" },
              { name: "Late Cancelled", value: "late_cancelled" },
              { name: "No-Show (Member)", value: "no_show_member" },
              { name: "No-Show (Specialist)", value: "no_show_specialist" },
            ]}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: "grow" }}>
          <Box className="content-listing">
            <TableContainer className="adminTable1">
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "Member",
                      "Specialist",
                      "Status",
                      "Appointment Date",
                      "Time",
                      "Actions",
                    ]?.map((cell, i) => (
                      <TableCell key={i} align="left">
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadings?.retrieveAll ? (
                    <TableSkell colLength={6} />
                  ) : (
                    data?.records?.map((appointment, i) => (
                      <TableRow
                        key={i}
                        tabIndex={-1}
                        role="checkbox"
                        sx={{
                          td: {
                            borderBottomWidth:
                              i === data?.records?.length - 1 ? "0" : "1px",
                          },
                        }}
                      >
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          <Box
                            gap={1}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Avatar src={appointment?.memberInfo?.image} />
                            <Typography>
                              {" "}
                              {appointment?.memberInfo?.name}{" "}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          <Box
                            gap={1}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Avatar src={appointment?.specialistInfo?.image} />
                            <Typography>
                              {appointment?.specialistInfo?.name}{" "}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={statusConfig[appointment?.appointmentStatus]?.label}
                            size="small"
                            sx={{
                              fontSize: "12.5px",
                              borderRadius: "20px",
                              backgroundColor:
                                statusConfig[appointment?.appointmentStatus]?.bg,
                              "& .MuiChip-label": {
                                color: `${statusConfig[appointment?.appointmentStatus]?.color
                                  } !important`,
                              },
                            }}
                          />{" "}
                        </TableCell>
                        <TableCell>
                          {formatDate(appointment?.startTime)}
                        </TableCell>
                        <TableCell>
                          {formatTime(appointment?.startTime) +
                            "-" + formatTime(appointment?.endTime)}
                        </TableCell>
                        <TableCell>
                          {Boolean(appointment?.chat) && (
                            <IconButton
                              size="small"
                              title="Accept"
                              color="primary"
                              sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                              onClick={() => { initiateChat(appointment?.chat) }}
                            ><Icons.ChatStrokeRounded />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}

                  {!data?.records?.length && !loadings?.retrieveAll && (
                    <TableRow sx={{ td: { borderBottom: "none" } }}>
                      <TableCell colSpan={6}>
                        <Typography variant="noRecords">
                          No appointments found!
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              pagination={data?.pagination}
              length={data?.records?.length}
              loading={loadings?.retrieveAll}
              cb={handleRetrieveAppointments}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, lg: "auto" }}>
          <Collapse
            orientation="horizontal"
            in={isActive}
            timeout={300}
            unmountOnExit
          >
            <Messages />
          </Collapse>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AllAppointments;
